import { ISearch } from './ISearch.model';
import * as _ from 'lodash';
import * as moment from 'moment';

export class InspectionRestoreItem implements ISearch {
  public id: string;
  public name: string;
  public location: string;
  public deletionDate: Date;
  public sectionId: string;
  public folderId: string;
  public pointId: string;
  public type: number;

  constructor() {}

  public search(query: string): boolean {
    const queryToLower = query.toLowerCase();
    return (
      !query ||
      (this.name && this.name.toLowerCase().indexOf(queryToLower) !== -1) ||
      (this.location && this.location.toLowerCase().indexOf(queryToLower) !== -1) ||
      (this.deletionDate != null && moment(this.deletionDate).format('DD.MM.YYYY').indexOf(queryToLower) !== -1)
    );
  }
}
